import React from 'react';
import PropTypes from 'prop-types';
import {
  IonModal,
  IonContent,
  IonList,
  IonItem,
  IonIcon,
  IonLabel,
  IonButtons,
  IonButton
} from '@ionic/react';
import { close } from 'ionicons/icons';

function LoyaltyTermsModal({ isOpen, setShowAlert, termsEndDate }) {
  const onCloseAction = () => {
    setShowAlert(false);
  }

  return (
    <IonModal isOpen={isOpen} className="custom-loyalty-terms-dlg">
      <IonItem lines="none" className="mt">
        <IonButtons slot="end">
          <IonButton
            onClick={onCloseAction}
            color="tertiary"
          >
            <IonIcon color="tertiary" slot="icon-only" icon={close} />
          </IonButton>
        </IonButtons>
      </IonItem>

      <IonContent>
        <IonList>
          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap" color="dark">
                <h3>Offer Terms &amp; Conditions</h3>
              </IonLabel>

              <IonLabel className="ion-text-wrap mt-3x" color="dark">
                {`Offer valid through ${termsEndDate} at this participating store. Must activate this offer to participate and pay using your Vēmos Pay account with linked payment method. This offer is exclusive to you and this Vēmos Pay account and cannot be reproduced, transferred or used by anyone else. Coins will be earned upon completion of this offer.`}
              </IonLabel>
            </div>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

LoyaltyTermsModal.propTypes = {
  isOpen: PropTypes.bool,
  setShowAlert: PropTypes.func,
  termsEndDate: PropTypes.string,
};

export default LoyaltyTermsModal;
